module.exports = __webpack_public_path__ + "img/Icon-3_parchment.9b59449e.svg";